var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSaturday = function SvgSaturday(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    style: {
      boxShadow: "0 0 7px #bebebea3",
      margin: "0 6px",
      borderRadius: 5
    },
    viewBox: "0 0 24 24"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#fff",
    rx: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1F4970",
    d: "M13.719 10.065a1.25 1.25 0 0 0-.563-.937q-.494-.337-1.244-.337-.537 0-.929.17a1.43 1.43 0 0 0-.61.46 1.1 1.1 0 0 0-.212.661q0 .312.144.537.15.225.388.38.243.149.52.251.277.098.533.162l.852.221a6.5 6.5 0 0 1 .856.278q.44.175.814.46.375.285.606.707.234.422.234 1.01 0 .741-.384 1.317-.378.575-1.103.908-.72.332-1.743.332-.98 0-1.696-.311-.716-.312-1.12-.882-.405-.575-.448-1.364h1.32q.04.473.308.788.272.312.694.465.426.15.933.15.559-.001.993-.176.44-.179.69-.494.252-.32.252-.746a.92.92 0 0 0-.222-.635 1.6 1.6 0 0 0-.592-.409 6 6 0 0 0-.84-.285l-1.03-.282q-1.05-.285-1.663-.839-.609-.554-.609-1.466 0-.755.41-1.317a2.7 2.7 0 0 1 1.107-.873q.7-.316 1.577-.316.885 0 1.564.311.681.312 1.073.857.393.541.41 1.244z"
  })));
};
export default SvgSaturday;